<template>
  <div
    class="w-full"
    :class="{
      hidden: prompts.length === 0
    }"
  >
    <div
      class="relative flex items-center justify-center overflow-hidden md:overflow-visible"
      v-touch:swipe.left="next"
      v-touch:swipe.right="prev"
    >
      <div
        data-test="tool_tips_div"
        class="overflow-x-hidden flex"
        ref="itemsContainer"
      >
        <div
          v-for="(item, index) in prompts"
          :key="index"
          class="shrink-0 grow-0"
          :style="
            index === 0
              ? {
                  ...itemStyle,
                  marginLeft: '0'
                }
              : itemStyle
          "
        >
          <button
            type="button"
            class="group enabled:hover:bg-gray-98 text-dlubal-blue text-left duration-300 transition-colors ease-in-out flex flex-col justify-between items-start gap-y-7 rounded-xl border border-gray-84 p-6 h-full w-[calc(100%-1px)]"
            @click="() => selectPrompt(item)"
          >
            <div class="flex flex-col gap-y-1.5">
              <div>
                <IconsStars class="h-[18px] w-[18px] md:mt-1 text-dlubal-blue" />
              </div>
              <p class="text-sm">
                {{ item.ngChatPrompt }}
              </p>
            </div>
            <UTag>
              {{ item.ngChatPromptCategory }}
            </UTag>
          </button>
        </div>
      </div>
    </div>
    <div
      data-test="tooltip_slider_div"
      class="flex items-center justify-center gap-x-3 mt-6 md:mt-8 text-dlubal-blue"
      :class="{ hidden: totalPages <= 1 }"
    >
      <button
        type="button"
        class="text-dlubal-blue enabled:hover:text-dlubal-cyan disabled:text-gray-70 duration-300 transition-colors ease-in-out"
        :disabled="isFirst"
        @click="prev"
      >
        <IconsAngleRight class="w-4 h-4 rotate-180" />
      </button>

      <span class="block w-[48px] text-center">{{ currentPage + 1 }}/{{ totalPages }}</span>

      <button
        type="button"
        class="text-dlubal-blue enabled:hover:text-dlubal-cyan disabled:text-gray-70 duration-300 transition-colors ease-in-out"
        :disabled="isLast"
        @click="next"
      >
        <IconsAngleRight class="w-4 h-4" />
      </button>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, ref, useTemplateRef, watch } from 'vue'
import { useCarousel } from '@/composables/useCarousel'
import { storeToRefs } from 'pinia'
import { breakpointsTailwind, useBreakpoints, useDebounceFn, useResizeObserver } from '@vueuse/core'
import UTag from '@/components/ui/UTag.vue'
import { usePromptsStore } from '@/stores/promptsStore'

const promptsStore = usePromptsStore()
const { loadMorePrompts, selectPrompt } = promptsStore
const { prompts } = storeToRefs(promptsStore)

const itemsCount = computed(() => prompts.value.length)
const breakpoints = useBreakpoints(breakpointsTailwind)
const computeCarouselItemsVisible = () => {
  if (breakpoints.isGreaterOrEqual('xl')) {
    return 3
  }

  if (breakpoints.isGreaterOrEqual('md')) {
    return 2
  }

  return 1
}

const itemsVisible = ref(computeCarouselItemsVisible())
const resizeHandler = useDebounceFn(() => {
  itemsVisible.value = computeCarouselItemsVisible()
}, 300)
useResizeObserver(document.body, resizeHandler)

const itemsContainerRef = useTemplateRef<HTMLDivElement>('itemsContainer')
const { prev, next, isFirst, isLast, currentPage, totalPages, itemStyle } = useCarousel(
  itemsContainerRef,
  itemsCount,
  itemsVisible,
  0
)

watch(isLast, () => {
  if (isLast.value) {
    loadMorePrompts()
  }
})
</script>
